module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel1-a03898b3f1d022df037f26b37720734c.jpg";